import React from 'react';
import { Button, T } from '@colonist/ui';
export const ActionButton = ({ isConnected, onConnectClick, onDisconnectClick, size })=>{
    return /*#__PURE__*/ React.createElement("div", null, !isConnected && /*#__PURE__*/ React.createElement(Button, {
        variant: "secondary",
        size: size,
        onClick: onConnectClick
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.settings.accounts.connect'
        }
    })), isConnected && /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: size,
        onClick: onDisconnectClick
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.settings.accounts.disconnect'
        }
    })));
};
